import React from 'react';
import { useIntl } from 'react-intl';

import { SurveyTranslation } from 'apis/merchant-gateway/nps/types';

export const SurveyLocaleContext = React.createContext<SurveyTranslation>({ id: 'en', translations: [] });

export const useSurveyIntl = () => {
  const intl = useIntl();
  const surveyTranslation = React.useContext(SurveyLocaleContext);

  const formatSurveyMessage = ({ fallback, resourceId }: { fallback: string; resourceId: string }) => {
    if (intl.locale === 'en' || surveyTranslation.id !== intl.locale) {
      return fallback;
    }

    return (
      surveyTranslation.translations.find(translation => translation.resourceId === resourceId)?.translation || fallback
    );
  };

  return { formatSurveyMessage };
};
